import { Skeleton } from "@/components/ui/skeleton";

function HomeContentSkeleton() {
  return (
    <div className="flex flex-1 flex-col gap-4 p-4 md:gap-8 md:p-8">
      <Skeleton className="h-8 w-40" />
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Skeleton className="h-56 w-full rounded-xl" />
        <div className="flex flex-col gap-6">
          <Skeleton className="h-32 w-full rounded-xl" />
          <Skeleton className="h-32 w-full rounded-xl" />
        </div>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton key={index} className="h-28 w-full rounded-xl" />
        ))}
      </div>
    </div>
  );
}

function HomeSkeleton() {
  return (
    <div className="min-h-screen bg-background">
      <aside className="fixed inset-y-0 left-0 z-40 hidden w-[90px] flex-col items-center gap-3 border-r border-border bg-card px-3 py-4 lg:flex">
        <Skeleton className="h-10 w-10 rounded-lg" />
        <div className="mt-2 flex w-full flex-col items-center gap-3">
          {Array.from({ length: 7 }).map((_, index) => (
            <Skeleton key={index} className="h-9 w-9 rounded-lg" />
          ))}
        </div>
      </aside>

      <header className="sticky top-0 z-30 flex h-14 items-center justify-between border-b border-border bg-background/95 px-4 lg:ml-[90px] lg:px-6">
        <Skeleton className="h-8 w-48" />
        <div className="flex items-center gap-3">
          <Skeleton className="h-9 w-9 rounded-full" />
          <Skeleton className="hidden h-9 w-24 rounded-md sm:block" />
        </div>
      </header>

      <main className="lg:ml-[90px]">
        <HomeContentSkeleton />
      </main>
    </div>
  );
}

export { HomeContentSkeleton, HomeSkeleton };
